import isBrowser from './isBrowser'

export default (id) => {
    return isBrowser() ? decodeURIComponent(escape(window.atob(id ))) : ''
}
